import { fork } from 'redux-saga/effects'
import { cursorSaga } from '../cursor'
import { nodeSaga } from '../node'
import { userSaga } from '../user'

export default function* rootSaga() {
    yield fork(cursorSaga)
    yield fork(nodeSaga)
    yield fork(userSaga)
}
